import { httpClient } from '@shared/api/http-client';

import { AUTH_LOGOUT_ENDPOINT } from './endpoints';

/**
 * Завершает cookie-сессию через BFF endpoint `/logout`.
 */
export const requestLogout = async (): Promise<void> => {
	await httpClient.post(AUTH_LOGOUT_ENDPOINT);
};
